import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.find.js";
import moment from 'moment';
import { padStart, capitalize, includes } from 'lodash';
import User from 'src/store/models/User';
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            context.Vue.filter('currency', function (value) {
              var showDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var languageCode = 'en-US';
              var currency = 'USD';

              if (User.me() && User.me().settings && User.me().settings.languageCode) {
                languageCode = User.me().settings.languageCode;
              }

              if (User.me() && User.me().account) {
                if (User.me().account.settings && User.me().account.settings.currencyCode) {
                  currency = User.me().account.settings.currencyCode;
                } else if (User.me().account.settings.currencySymbol) {
                  currency = User.me().account.settings.currencySymbol;

                  var _formatter = new Intl.NumberFormat(languageCode);

                  return currency + ' ' + _formatter.format(value);
                }
              }

              var formatter = new Intl.NumberFormat(languageCode, {
                style: 'currency',
                currency: currency,
                maximumFractionDigits: showDecimals ? 2 : 0
              });
              return formatter.format(value !== null && value !== void 0 ? value : 0); // $2,500.00
            });
            context.Vue.filter('percentage', function (value) {
              return (value * 100).toFixed(2) + '%';
            });
            context.Vue.filter('number', function (value) {
              var languageCode = 'en-US';

              if (User.me() && User.me().settings && User.me().settings.languageCode) {
                languageCode = User.me().settings.languageCode;
              }

              var formatter = new Intl.NumberFormat(languageCode);
              return formatter.format(value); // 2,500.00
            });
            context.Vue.filter('formatTimeHtml', function (minutes) {
              var settingFormat = 'normal',
                  formattedHours = 0,
                  formattedMinutes = '00',
                  pippo = 0;

              if (User.me() && User.me().settings && User.me().settings.timeFormat) {
                settingFormat = User.me().settings.timeFormat;
              }

              if (!isNaN(minutes)) {
                var formattedTime = Math.abs(minutes);
                formattedHours = formattedTime / 60 > 0 ? parseInt(formattedTime / 60) : 0;
                formattedMinutes = parseInt(formattedTime / 60) > 0 ? ('0' + (formattedTime - parseInt(formattedTime / 60) * 60)).slice(-2) : formattedTime;
              }

              switch (settingFormat) {
                case 'normal':
                  pippo = formattedHours === 0 ? (formattedMinutes !== '00' ? formattedMinutes : '0') + '<span class="time-label">m</span>' : formattedMinutes === '00' ? formattedHours + '<span class="time-label">h</span>' : formattedHours + '<span class="time-label" style="margin-right: 2px">h</span>' + formattedMinutes + '<span class="time-label">m</span>';
                  return pippo;

                case 'hipster':
                  return formattedHours + '<span class="time-label">h</span>' + ('0' + formattedMinutes).slice(-2);

                case 'decimal':
                  return (minutes / 60).toFixed(2) + '<span class="time-label">h</span>';

                default:
                  return formattedHours + ':' + ('0' + formattedMinutes).slice(-2);
              }
            });
            context.Vue.filter('formatTimeHtmlReports', function (minutes) {
              var settingFormat = 'normal',
                  formattedHours = 0,
                  formattedMinutes = '00',
                  pippo = 0;

              if (User.me() && User.me().settings && User.me().settings.timeFormatReports) {
                settingFormat = User.me().settings.timeFormatReports;
              }

              if (!isNaN(minutes)) {
                var formattedTime = Math.abs(minutes);
                formattedHours = formattedTime / 60 > 0 ? parseInt(formattedTime / 60) : 0;
                formattedMinutes = formattedTime / 60 > 0 ? ('0' + (formattedTime - parseInt(formattedTime / 60) * 60)).slice(-2) : ('0' + formattedTime).slice(-2);
              }

              switch (settingFormat) {
                case 'normal':
                  pippo = formattedHours === 0 ? (formattedMinutes !== '00' ? formattedMinutes : '0') + 'm' : formattedMinutes === '00' ? formattedHours + 'h' : formattedHours + 'h' + formattedMinutes + 'm';
                  return pippo;

                case 'hipster':
                  return formattedHours + 'h ' + formattedMinutes;

                case 'decimal':
                  return (minutes / 60).toFixed(2) + 'h';

                default:
                  return formattedHours + ':' + formattedMinutes;
              }
            });
            context.Vue.filter('formattedMinutes', function (minutes) {
              if (!isNaN(minutes)) {
                var formattedMinutes = Math.abs(minutes);

                if (formattedMinutes > 60) {
                  return (minutes < 0 ? '-' : '') + Math.floor(formattedMinutes / 60) + 'h' + formattedMinutes % 60 + 'm';
                }

                return minutes + 'm';
              }

              return '0m';
            });
            context.Vue.filter('minutesToHourAndMinutes', function (minutes) {
              if (!isNaN(minutes)) {
                return padStart(parseInt(minutes / 60), 2, '0') + ':' + padStart(minutes % 60, 2, '0');
              }

              return '00:00';
            });
            context.Vue.filter('dateFormat', function (date, format) {
              moment.locale(User.me().settings.appLanguage);

              if (!format) {
                format = User.me().settings.dateFormat ? User.me().settings.dateFormat.toUpperCase() : 'YYYY/MM/DD';
              }

              if (date instanceof moment) {
                return date.format(format);
              } else {
                return moment(date).format(format);
              }
            });
            context.Vue.filter('timestampToDate', function (timestamp, format) {
              return moment.unix(timestamp).format(format);
            });
            context.Vue.filter('dateFormatForEntriesGroup', function (date) {
              moment.locale(User.me().settings.appLanguage);
              var momentDate = moment(date),
                  calendarDay = momentDate.calendar(),
                  day = capitalize(includes(['today', 'yesterday'], calendarDay) ? calendarDay : momentDate.format('dddd')),
                  year = momentDate.format('YYYY') !== moment().format('YYYY') ? momentDate.format('YYYY | ') : '';
              return year + day + momentDate.format(', DD MMM');
            });
            context.Vue.filter('fromNow', function (date) {
              return moment(date).fromNow();
            });
            context.Vue.filter('truncate', function (text, length, clamp) {
              clamp = clamp || '...';
              return text.length > length ? text.slice(0, length) + clamp : text;
            });
            context.Vue.filter('industry', function (value) {
              var industries = [{
                value: null,
                label: this.$t('general.all')
              }, {
                value: 0,
                label: this.$t('general.none')
              }, {
                value: 1,
                label: this.$t('industries.marketing_communication')
              }, {
                value: 2,
                label: this.$t('industries.software_development')
              }, {
                value: 3,
                label: this.$t('industries.media_entertainment')
              }, {
                value: 4,
                label: this.$t('industries.business_consulting')
              }, {
                value: 5,
                label: this.$t('industries.real_estate')
              }, {
                value: 6,
                label: this.$t('industries.education')
              }, {
                value: 7,
                label: this.$t('industries.trasportation')
              }, {
                value: 8,
                label: this.$t('industries.law')
              }, {
                value: 9,
                label: this.$t('industries.health')
              }, {
                value: 10,
                label: this.$t('general.n_a')
              }, {
                value: 11,
                label: this.$tc('general.other', 1)
              }];
              var industry = industries.find(function (industry) {
                return industry.value === value;
              });
              return industry ? industry.label : '-';
            });
            context.Vue.filter('workflow', function (value) {
              var workflows = [{
                value: null,
                label: this.$t('general.all')
              }, {
                value: 0,
                label: this.$t('general.none')
              }, {
                value: 1,
                label: this.$tc('general.project', 1)
              }, {
                value: 2,
                label: this.$t('general.product')
              }, {
                value: 3,
                label: this.$t('general.hourly')
              }, {
                value: 4,
                label: this.$t('general.n_a')
              }, {
                value: 5,
                label: this.$tc('general.other', 1)
              }];
              var workflow = workflows.find(function (workflow) {
                return workflow.value === value;
              });
              return workflow ? workflow.label : '-';
            });
            context.Vue.filter('humanReadableBytes', function (bytes) {
              if (bytes < 1024) return bytes + 'B';
              if (bytes < 10 * 1024 * 1024) return (bytes / 1024).toFixed(0) + 'KB';
              if (bytes < 10 * 1024 * 1024 * 1024) return (bytes / 1024 / 1024).toFixed(0) + 'MB';
              return (bytes / 1024 / 1024 / 1024).toFixed(0) + 'GB';
            });
            context.Vue.filter('role', function (value) {
              var roles = [{
                value: 1,
                label: this.$t('roles.accountant')
              }, {
                value: 2,
                label: this.$t('roles.business_development_professional')
              }, {
                value: 3,
                label: this.$t('roles.business_owner_or_founder')
              }, {
                value: 4,
                label: this.$t('roles.customer_service_representative')
              }, {
                value: 5,
                label: this.$t('roles.data_science_engineer')
              }, {
                value: 6,
                label: this.$t('roles.designer')
              }, {
                value: 7,
                label: this.$t('roles.devOps_engineer')
              }, {
                value: 8,
                label: this.$t('roles.facilities_manager')
              }, {
                value: 9,
                label: this.$t('roles.financial_advisor')
              }, {
                value: 10,
                label: this.$t('roles.fitness_coach')
              }, {
                value: 11,
                label: this.$t('roles.health_professional')
              }, {
                value: 12,
                label: this.$t('roles.human_resources_professional')
              }, {
                value: 13,
                label: this.$t('roles.information_technology_rofessional')
              }, {
                value: 14,
                label: this.$t('roles.legal_professional')
              }, {
                value: 15,
                label: this.$t('roles.marketer')
              }, {
                value: 16,
                label: this.$t('roles.mechanical_engineer')
              }, {
                value: 17,
                label: this.$t('roles.office_manager')
              }, {
                value: 18,
                label: this.$t('roles.operations_professional')
              }, {
                value: 19,
                label: this.$t('roles.personal_assistant')
              }, {
                value: 20,
                label: this.$t('roles.president_or_ceo')
              }, {
                value: 21,
                label: this.$t('roles.product_manager')
              }, {
                value: 22,
                label: this.$t('roles.project_manager')
              }, {
                value: 23,
                label: this.$t('roles.property_manager')
              }, {
                value: 24,
                label: this.$t('roles.public_relations_professional')
              }, {
                value: 25,
                label: this.$t('roles.real_estate_agent')
              }, {
                value: 26,
                label: this.$t('roles.recruiter')
              }, {
                value: 27,
                label: this.$t('roles.salesperson')
              }, {
                value: 28,
                label: this.$t('roles.school_administrator')
              }, {
                value: 29,
                label: this.$t('roles.software_engineer')
              }, {
                value: 30,
                label: this.$t('roles.student')
              }, {
                value: 31,
                label: this.$t('roles.teacher_or_professor')
              }, {
                value: 32,
                label: this.$t('roles.web_engineer')
              }, {
                value: 33,
                label: this.$t('roles.writer_or_editor')
              }, {
                value: 34,
                label: this.$tc('general.other', 1)
              }];
              var role = roles.find(function (role) {
                return role.value === value;
              });
              return role ? role.label : '-';
            });
            context.Vue.filter('timeframe', function (value) {
              var timeframes = [{
                value: 'today',
                label: context.app.i18n.t('timeframe.today')
              }, {
                value: 'yesterday',
                label: context.app.i18n.t('timeframe.yesterday')
              }, {
                value: 'week_this',
                label: context.app.i18n.t('timeframe.this_week')
              }, {
                value: 'month_this',
                label: context.app.i18n.t('timeframe.this_month')
              }, {
                value: 'year_this',
                label: context.app.i18n.t('timeframe.this_year')
              }, {
                value: 'week_last',
                label: context.app.i18n.t('timeframe.last_week')
              }, {
                value: 'month_last',
                label: context.app.i18n.t('timeframe.last_month')
              }, {
                value: 'days_7',
                label: context.app.i18n.t('timeframe.last_7_days')
              }, {
                value: 'days_15',
                label: context.app.i18n.t('timeframe.last_15_days')
              }, {
                value: 'days_30',
                label: context.app.i18n.t('timeframe.last_30_days')
              }, {
                value: 'months_3',
                label: context.app.i18n.t('timeframe.last_3_months')
              }, {
                value: 'months_6',
                label: context.app.i18n.t('timeframe.last_6_months')
              }, {
                value: 'months_12',
                label: context.app.i18n.t('timeframe.last_12_months')
              }];
              var timeframe = timeframes.find(function (timeframe) {
                return timeframe.value === value;
              });
              return timeframe ? timeframe.label : '-';
            });

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();